module.exports = __webpack_public_path__ + "img/web3.d916c570.svg";